var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClouds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 86,
    viewBox: "0 0 107 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.2257,
    cy: 29.6593,
    r: 28.8805,
    fill: "#8075FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9115 37.2345C72.9115 50.047 61.677 60.4336 47.8186 60.4336C33.9601 60.4336 22.7257 50.047 22.7257 37.2345C22.7257 24.4219 33.9601 14.0353 47.8186 14.0353C61.677 14.0353 72.9115 24.4219 72.9115 37.2345Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8672 59.4867C55.8672 73.0836 43.7849 84.1061 28.8805 84.1061C13.9762 84.1061 1.8938 73.0836 1.8938 59.4867C1.8938 45.8897 13.9762 34.8672 28.8805 34.8672C43.7849 34.8672 55.8672 45.8897 55.8672 59.4867Z",
    fill: "#FBFBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107 57.5929C107 72.2357 92.162 84.1061 73.8584 84.1061C55.5548 84.1061 40.7168 72.2357 40.7168 57.5929C40.7168 42.95 55.5548 31.0796 73.8584 31.0796C92.162 31.0796 107 42.95 107 57.5929Z",
    fill: "#FBFBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.354 47.1769H74.8053V84.1061H29.354V47.1769Z",
    fill: "#FBFBFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0177 39.1283C71.0177 51.9408 59.7832 62.3274 45.9248 62.3274C32.0663 62.3274 20.8319 51.9408 20.8319 39.1283C20.8319 26.3158 32.0663 15.9292 45.9248 15.9292C59.7832 15.9292 71.0177 26.3158 71.0177 39.1283Z",
    fill: "#6320EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9735 61.3805C53.9735 74.9775 41.8911 86 26.9867 86C12.0824 86 0 74.9775 0 61.3805C0 47.7836 12.0824 36.7611 26.9867 36.7611C41.8911 36.7611 53.9735 47.7836 53.9735 61.3805Z",
    fill: "#6320EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.106 59.4867C105.106 74.1296 90.2682 86 71.9646 86C53.661 86 38.823 74.1296 38.823 59.4867C38.823 44.8438 53.661 32.9734 71.9646 32.9734C90.2682 32.9734 105.106 44.8438 105.106 59.4867Z",
    fill: "#6320EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4602 49.0708H72.9115V86H27.4602V49.0708Z",
    fill: "#6320EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.56d9099750404864527d5989b37ffe31.svg";
export { ForwardRef as ReactComponent };